export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7910.a3ff80a9.jpg";